const STANDARD_WHITE_1 = {
  url: 'https://res.insta360.com/static/d129be48c124325a652f1e852648178d/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  urlL: 'https://res.insta360.com/static/997fbdfad568a3fdcc26f42527f0745a/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@3x.jpg',
  url_m:
    'https://res.insta360.com/static/d129be48c124325a652f1e852648178d/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  url_s:
    'https://res.insta360.com/static/b3ca4ad76eeba002aa40998abb46bcd0/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD.jpg',
};
const STANDARD_BLACK_1 = {
  url: 'https://res.insta360.com/static/51adba17faa077e3c690aafae6022874/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/55df2005b506d1b44affc2680a2ce62f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@3x.jpg',
  url_m:
    'https://res.insta360.com/static/51adba17faa077e3c690aafae6022874/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  url_s:
    'https://res.insta360.com/static/09657ea4bcd87906148aca94cea486a6/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91.jpg',
};
const STANDARD_2 = {
  url: 'https://res.insta360.com/static/d4b22e3bbe769fc55097702956774ce9/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  urlL: 'https://res.insta360.com/static/fb28d4a139983db4ab5d07465b526d78/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@3x.jpg',
  url_m:
    'https://res.insta360.com/static/d4b22e3bbe769fc55097702956774ce9/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  url_s: 'https://res.insta360.com/static/99b0b8364a29d408b91221008447777a/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002.jpg',
};
const STANDARD_3 = {
  url: 'https://res.insta360.com/static/7c8e2eb0686b6347e7c4e8be5bd4b76f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  urlL: 'https://res.insta360.com/static/3d495f65d72f9b37216032eaf19fab59/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@3x.jpg',
  url_m:
    'https://res.insta360.com/static/7c8e2eb0686b6347e7c4e8be5bd4b76f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  url_s: 'https://res.insta360.com/static/e79ad4904fd2d06064d08b3bd62ee078/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003.jpg',
};
const STANDARD_4 = {
  url: 'https://res.insta360.com/static/5491efd6fbe722dd46ec2e4398c9202a/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  urlL: 'https://res.insta360.com/static/5f0d0c9973ace45f775e23fe3c05c84d/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@3x.jpg',
  url_m:
    'https://res.insta360.com/static/5491efd6fbe722dd46ec2e4398c9202a/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  url_s: 'https://res.insta360.com/static/2c84faa40f5b26c29f8622b7037ecf29/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004.jpg',
};
const FAMILY_WHITE_1 = {
  url: 'https://res.insta360.com/static/fe6a0226cd8b7dfaaf20211dab72343e/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/2ba13ee29c3de7e4f05cc70e13962f38/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/fe6a0226cd8b7dfaaf20211dab72343e/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/fb6cf415e060f8b6191734183d834b1b/01.jpg',
};
const FAMILY_BLACK_1 = {
  url: 'https://res.insta360.com/static/2fa828ff82256cc210cb360d0b8ab2cc/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/556893da1d8e43f15b753a851c9da1b9/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/2fa828ff82256cc210cb360d0b8ab2cc/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/01310cd0a4dac1ddfd2c777a36b9e9f5/02-%E9%BB%91.jpg',
};
const FAMILY_2 = {
  url: 'https://res.insta360.com/static/68a8c5abced5d8194299ad038489931f/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/2087ccb3d267779668eec599cb66d3a2/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/68a8c5abced5d8194299ad038489931f/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/264116c751afdba731f5669abc73549a/03.jpg',
};
const FAMILY_3 = {
  url: 'https://res.insta360.com/static/0c2c9c27da194565dd65e94384d6d368/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/1f9407d3f8490cceadb9bd1caa37318e/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/0c2c9c27da194565dd65e94384d6d368/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/58c0a479f946ed12b86c045dd664e83c/04.jpg',
};
const FAMILY_4 = {
  url: 'https://res.insta360.com/static/1f184d91d73ad6bda1f0cc340f884545/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/1e38f205b2fcd2ab9d7d5c2bb660de83/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/1f184d91d73ad6bda1f0cc340f884545/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/35da65234f082d9529850721a5298438/05.jpg',
};
const ULTIMATE_WHITE_1 = {
  url: 'https://res.insta360.com/static/ce9e604cc2c63e79c4596ca13b7942b9/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/d940cfad4b9dbc4f514be540f67c5d31/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/ce9e604cc2c63e79c4596ca13b7942b9/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/ffc8559fc4443ccae75e6cceecab13b5/01.jpg',
};
const ULTIMATE_BLACK_1 = {
  url: 'https://res.insta360.com/static/d0ed92c622905a23a781b28c5d3a959d/02-%E9%BB%91-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/ddffd31085ea2a6fc593463116079d0c/02-%E9%BB%91-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/d0ed92c622905a23a781b28c5d3a959d/02-%E9%BB%91-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/59b056588f0723b4efa8f98b555138af/02-%E9%BB%91-%E9%BB%91.jpg',
};
const ULTIMATE_2 = {
  url: 'https://res.insta360.com/static/1d5617d083a5c458c6eeb0046e66f997/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/c10267c12baaab1771fc0bc0104722da/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/1d5617d083a5c458c6eeb0046e66f997/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/5d4f374055fbef986d970224ffdd2691/03.jpg',
};
const ULTIMATE_3 = {
  url: 'https://res.insta360.com/static/767b499bed4f9a5173873d53f95844b3/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/1c5af70653b8237c46b94534c53cc4a3/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/767b499bed4f9a5173873d53f95844b3/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/b952d3851519a5e8d9c2b1d0160805df/04.jpg',
};
const ULTIMATE_4 = {
  url: 'https://res.insta360.com/static/b64b06aa1430831fbd5e3466e5709bf8/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/12c1545a5232627cf8c69c076f686c04/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/b64b06aa1430831fbd5e3466e5709bf8/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/08288b10cb7c9dca8d72d3f7653938ac/05.jpg',
};

const ACTION_WHITE_1 = {
  url: 'https://res.insta360.com/static/cd3aa2a8153a7ab1f60b8aed8451282b/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/69d6db03a215cb5cd9ed0585b425ed7a/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/cd3aa2a8153a7ab1f60b8aed8451282b/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/431808eee9a13ef45a89f4f0c599c2c6/01.jpg',
};
const ACTION_BLACK_1 = {
  url: 'https://res.insta360.com/static/b2d5b16e6555827a97ca03ff89379d26/02-%E9%BB%91-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/172541dd75728de140d81fb6f04fdd62/02-%E9%BB%91-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/b2d5b16e6555827a97ca03ff89379d26/02-%E9%BB%91-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/aaee0a131137d7a993addf4303dfc839/02-%E9%BB%91-%E9%BB%91.jpg',
};
const ACTION_2 = {
  url: 'https://res.insta360.com/static/e4c984f6ad2999102f2befc6b02e5df8/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/b57bbd39a577508746d6e2921092b681/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/e4c984f6ad2999102f2befc6b02e5df8/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/9deae082134af51004ac0bfa48141215/03.jpg',
};
const ACTION_3 = {
  url: 'https://res.insta360.com/static/6b78a7a0fa5845e5227ae5432074fa4c/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/ba86ce3d8f2b92ab15d4adc6eb28fbe7/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/6b78a7a0fa5845e5227ae5432074fa4c/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/5e6a0fb01892f999502c37e1b1599f12/04.jpg',
};

const ACTION_4 = {
  url: 'https://res.insta360.com/static/70b4711de38077b3db8af4a60682c140/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/ba1eda61fd48242c20ed461fe1ac428e/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/70b4711de38077b3db8af4a60682c140/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/9e02937a8867eb811e78ab3ae0e296c5/05.jpg',
};
const CREATOR_WHITE_1 = {
  url: 'https://res.insta360.com/static/091cda2c1056f3e24504099278fbc6a3/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/53826bb37c1c809acb62544cc01c134b/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/091cda2c1056f3e24504099278fbc6a3/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/6e7ce8abc9d09f83dac09d1d03e8df69/01.jpg',
};
const CREATOR_BLACK_1 = {
  url: 'https://res.insta360.com/static/d5884207f279f013038dff2daca5ee30/02-%E9%BB%91-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/154e68b336637e613cb6fa7cbcc9ec87/02-%E9%BB%91-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/d5884207f279f013038dff2daca5ee30/02-%E9%BB%91-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/7ec09dbb6564322f01393a05c02287ab/02-%E9%BB%91-%E9%BB%91.jpg',
};
const CREATOR_2 = {
  url: 'https://res.insta360.com/static/ce4933223cce075b7c2f0e095e8d3cc5/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/9a458c2546435a26649f472155eabd75/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/ce4933223cce075b7c2f0e095e8d3cc5/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/291b3c81563c0b0cb40eb87248b74df5/03.jpg',
};
const CREATOR_3 = {
  url: 'https://res.insta360.com/static/34f17c791fbc2ad28fa63f4e26b07ddc/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/fd9fc9d2dfc1c1736c1fef6b8bfc59f5/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/34f17c791fbc2ad28fa63f4e26b07ddc/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/26d88a95fdbd6688a9a4ab43baf122ea/04.jpg',
};
const CREATOR_4 = {
  url: 'https://res.insta360.com/static/2565bd39f535e6ec1093573f2e6ab7e7/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/8d33717475f7db77278518edc9ba0b95/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/2565bd39f535e6ec1093573f2e6ab7e7/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/242839b6ea13f1af1e06aae2c4d90034/05.jpg',
};
const WATER_WHITE_1 = {
  url: 'https://res.insta360.com/static/4b0dcb9519fd4afec6a6113cf1469f82/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/ae7e0385e915acc4798a1e7bb87558f3/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/4b0dcb9519fd4afec6a6113cf1469f82/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/048ea13f811b7dc8cc122ec67d662982/01.jpg',
};
const WATER_BLACK_1 = {
  url: 'https://res.insta360.com/static/94f1969e0434713bd3fe36f21c62d14b/02-%E9%BB%91-%E9%BB%91@2x.jpgj',
  urlL: 'https://res.insta360.com/static/fc9318bfcbb3c670a28a396254502ec9/02-%E9%BB%91-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/94f1969e0434713bd3fe36f21c62d14b/02-%E9%BB%91-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/bba84c07ea13f503b2d2b153b78d62f6/02-%E9%BB%91-%E9%BB%91.jpg',
};
const WATER_2 = {
  url: 'https://res.insta360.com/static/1e85ad34949b9b8caf87dc09d888f2cb/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/0d945f56e34ea988d904682d03104741/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/1e85ad34949b9b8caf87dc09d888f2cb/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/b4c8f71ed250d2f8435469c06d7db1ae/03.jpg',
};
const WATER_3 = {
  url: 'https://res.insta360.com/static/92cf5cd6047ed7c8b14b9d04e63d7e1e/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/4f17cea171ecc81438f9d0a64ba4fdfc/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/92cf5cd6047ed7c8b14b9d04e63d7e1e/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/2fc3635f45cab864c4a253fdc6052a48/04.jpg',
};

const resourcesMapperES = new Map([
  [3125, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3135, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3120, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3130, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3121, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3131, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3126, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3136, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3469, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3470, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3471, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3472, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3122, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3132, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3127, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3137, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3478, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3479, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3480, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3481, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3123, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3133, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3128, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
  [3138, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
]);

export default resourcesMapperES;
